import { render } from "./IntroTableB.vue?vue&type=template&id=2fa8c64e"
import script from "./IntroTableB.vue?vue&type=script&lang=js"
export * from "./IntroTableB.vue?vue&type=script&lang=js"

import "./IntroTableB.vue?vue&type=style&index=0&id=2fa8c64e&lang=less"

import exportComponent from "D:\\WorkSpace\\Codes\\website-apps\\frontend\\report\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__